import { render } from "./header.vue?vue&type=template&id=20c0042f"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/layouts/partials/header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20c0042f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20c0042f', __exports__)) {
    console.log('reload')
    api.reload('20c0042f', __exports__)
  }
  
  module.hot.accept("./header.vue?vue&type=template&id=20c0042f", () => {
    console.log('re-render')
    api.rerender('20c0042f', render)
  })

}


export default __exports__